import React from "react";

import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";
import AdminDataExperienceRoutes from "./AdminDataExperienceRoutes";

const AdminDataExperienceScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Import Data Experience",
      page: "Import Data Experience Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <AdminDataExperienceRoutes />
      </Track>
    </div>
  );
};

export default AdminDataExperienceScreen;
